import { Module } from 'vuex'
import { RootState } from '../../../../store/state_models'
import { AdvancedSettingsStoreModule } from '../../types/AdvancedSettings'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'


export const advancedSettings: Module<AdvancedSettingsStoreModule, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
